import { SpendTypeEnum } from '..';
import { SPEND_LABELS } from '../ClassificationTable/utils';

const getContentText = (spendType: SpendTypeEnum, hasMore: boolean) => {
  const type = SPEND_LABELS[spendType].toLowerCase();
  const moreType =
    spendType === SpendTypeEnum.THIRD_PARTY
      ? SpendTypeEnum.PERSONNEL
      : SpendTypeEnum.THIRD_PARTY;

  if (hasMore) {
    return `All ${type} spend data has been classified and published.\n\nNewly uploaded ${SPEND_LABELS[moreType]} data has not yet been classified. Click the button below to classify this data.`;
  }

  return `All ${type} spend data has been classified and published.`;
};

export const getText = (spendType: SpendTypeEnum, hasMore: boolean) => {
  const moreType =
    spendType === SpendTypeEnum.THIRD_PARTY
      ? SpendTypeEnum.PERSONNEL
      : SpendTypeEnum.THIRD_PARTY;

  return {
    content: getContentText(spendType, hasMore),
    header: `${SPEND_LABELS[spendType]} spend published`,
    classifyMoreButton: `Classify ${SPEND_LABELS[moreType]} data`,
    navigateButton: `Go to summary`,
  };
};
